import { circleProgressChart } from "#root/dashboard/charts/components/circle_progress_chart";
import { hidePopup, showPopup } from "../bottom-popup";
export function circularProgressChartBox(chart, chartCard) {
  const chartHolder = document.createElement("div");
  chartHolder.classList.add("circular-progress-chart-list");
  const progressChartsContainer = document.createElement("div");
  progressChartsContainer.classList.add("circular-progress-charts-container");
  chartHolder.appendChild(progressChartsContainer);
  const circleProgressContainer = document.createElement("div");
  circleProgressContainer.classList.add("circle-progress-chart");
  progressChartsContainer.appendChild(circleProgressContainer);
  const chartContent = document.createElement("div");
  chartContent.classList.add("chart-content");
  circleProgressContainer.appendChild(chartContent);
  const chartValue = document.createElement("div");
  chartValue.classList.add("chart-center-value");
  chartContent.appendChild(chartValue);
  const canvas = document.createElement("canvas");
  canvas.classList.add("circle-progress-canvas");
  chartContent.appendChild(canvas);
  chartCard.dataset.type = "circular-progress";
  let eventRegistry = [];
  requestAnimationFrame(async () => {
    const chartCtrl = await circleProgressChart(canvas, chart, {
      onHover: (hovered, oldHovered, direct) => {
        if (hovered) {
          chartValue.textContent = hovered.value + "%";
          const idx = chart.sets.indexOf(hovered);
          chartCard.querySelector(`.chart-legend`).classList.add("active");
          [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => item.classList.toggle("active", idx == item.dataset.idx));

          if (direct) {
            showPopup().textContent = hovered.label;
          }
        } else {
          if (oldHovered) {
            const idx = chart.sets.indexOf(oldHovered);
            chartCard.querySelector(`.chart-legend`).classList.remove("active");
            [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => item.classList.remove("active"));
          }

          hidePopup();
        }

        chartCard.classList.toggle("chart-active", !!hovered);
        chartCard.style.setProperty("--chart-hover-color", hovered ? hovered.color : "");
      }
    });
    eventRegistry.push(() => {
      chartCtrl.destroy();
    });
    [...chartCard.querySelectorAll(`.chart-legend-item`)].forEach(item => {
      let setActive = e => {
        chartCtrl.setActive(chart.sets[item.dataset.idx]);
      };

      let setBlur = () => {
        chartCtrl.blur();
      };

      item.addEventListener("mouseenter", setActive, {
        passive: true
      });
      item.addEventListener("mouseleave", setBlur, {
        passive: true
      });
      eventRegistry.push(() => {
        item.removeEventListener("mouseenter", setActive, {
          passive: true
        });
        item.removeEventListener("mouseleave", setBlur, {
          passive: true
        });
      });
    });
  });

  chartHolder.destroy = () => {
    eventRegistry.forEach(fn => fn());
  };

  return chartHolder;
}